// Loads all compound JSON files at build time. Vite's import.meta.glob with
// eager:true bakes them into the bundle — no runtime fetches.

export type Compound = {
  id: string;
  display_name: string;
  scientific_name: string;
  aliases: string[];
  goals: string[];
  description: string;
  evidence_stars: number;
  typical_dose_mg: { min: number; max: number };
  timing: string[];
  cycle_required: boolean;
  cycle_pattern: string | null;
  warnings: string[];
  interactions: string[];
  references: { type: string; url: string; note: string }[];
  amazon_asin?: string;
  amazon_product_name?: string;
  sources?: string[];
  source_doses?: Record<string, number>;
  source_units?: Record<string, string>;
  source_dose_options?: Record<string, number[]>;
  components?: { compound_id: string; dose_mg: number; unit?: string; dose_value?: number }[];
  stacks_well_with?: string[];
  affiliate_vendors: { name: string; url_template: string }[];
};

const modules = import.meta.glob('../../../data/compounds/*.json', { eager: true }) as Record<string, { default: any }>;

export const COMPOUNDS: Compound[] = Object.entries(modules)
  .filter(([path]) => !path.endsWith('/index.json'))
  .map(([, mod]) => mod.default as Compound)
  .sort((a, b) => a.display_name.localeCompare(b.display_name));

export const COMPOUND_BY_ID: Record<string, Compound> = Object.fromEntries(
  COMPOUNDS.map((c) => [c.id, c]),
);

export function compoundsForGoal(goalId: string): Compound[] {
  return COMPOUNDS.filter((c) => c.goals.includes(goalId));
}
